export default "__VITE_ASSET__DSmLHaPt__"